import React from 'react';
import { Divider, Alert } from '@patternfly/react-core';
import { translate as __ } from 'foremanReact/common/I18n';

export const StartsBeforeErrorAlert = () => (
  <>
    <Alert
      variant="danger"
      title={__("'Starts before' date must in the future")}
    >
      {__(
        'Please go back to "Schedule" - "Future execution" step to fix the error'
      )}
    </Alert>
    <Divider component="div" />
  </>
);



// WEBPACK FOOTER //
// ./vendor/ruby/2.7.0/gems/foreman_remote_execution-10.1.1/webpack/JobWizard/StartsBeforeErrorAlert.js